export default __webpack_public_path__ + "static/media/comparator.1ba129df.svg";